
        var result = require("!!../../node_modules/css-loader/index.js!./styles.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/styles.css
// module id = 639
// module chunks = 0